import React from 'react';
import proptypes from 'prop-types';
import { Tile as TileElement, TileContent, TileText } from '@one-thd/sui-atomic-components';
import { Tooltip } from '../tooltip/tooltip';
import { AvailabilityTooltipContent } from '../tooltip/availability-tooltip-content';

const { string, shape, bool, func } = proptypes;

export const TileComponent = ({
  value,
  isSelected,
  isAvailable,
  isFabricType,
  onClick,
  onTileMouseEnter,
  onTileMouseLeave,
  showMainTooltip,
  showUnavailableTooltip,
  anchorRef,
  hoveredCombinationDetails,
  onPopoverClose,
  unavailableTooltipMessage,
}) => {
  const tileChild = (
    <div onMouseEnter={onTileMouseEnter} onMouseLeave={onTileMouseLeave}>
      <TileElement
        onClick={onClick}
        aria-label={value}
        value={value}
        selected={isSelected}
        unavailable={!isAvailable && !isFabricType}
        data-testid="text-tile"
      >
        <TileContent>
          <TileText decoration={(!isAvailable && !isFabricType) && 'line-through'}>
            {value}
          </TileText>
        </TileContent>
      </TileElement>
    </div>
  );

  const shouldShowPopover = (showMainTooltip || showUnavailableTooltip) && anchorRef?.current;

  return (
    <>
      {tileChild}
      {shouldShowPopover && (
        <Tooltip
          key={`popover-${value}`}
          open={anchorRef?.current}
          anchorEl={anchorRef?.current}
          onClose={onPopoverClose}
          placement={showMainTooltip ? 'top' : 'bottom'}
        >
          <AvailabilityTooltipContent
            showMainTooltip={showMainTooltip}
            showUnavailableTooltip={showUnavailableTooltip}
            hoveredCombinationDetails={hoveredCombinationDetails}
            unavailableTooltipMessage={unavailableTooltipMessage}
          />
        </Tooltip>
      )}
    </>
  );
};

TileComponent.propTypes = {
  value: string.isRequired,
  isSelected: bool.isRequired,
  isAvailable: bool.isRequired,
  isFabricType: bool,
  onClick: func.isRequired,
  onTileMouseEnter: func.isRequired,
  onTileMouseLeave: func.isRequired,
  showMainTooltip: bool,
  showUnavailableTooltip: bool,
  anchorRef: shape({}),
  hoveredCombinationDetails: shape({}),
  onPopoverClose: func.isRequired,
  unavailableTooltipMessage: string,
};

TileComponent.defaultProps = {
  isFabricType: false,
  showMainTooltip: false,
  showUnavailableTooltip: false,
  anchorRef: null,
  hoveredCombinationDetails: {},
  unavailableTooltipMessage: '',
};